import { makeStyles } from '@material-ui/core/styles';

export const useFormCountryStyles = makeStyles(theme => ({
  formCountry: {
    flexGrow: 1
  }
}));
